// extracted by mini-css-extract-plugin
module.exports = {"mobileOnly":"Divider_mobileOnly__OXcpP","noMargin":"Divider_noMargin__IRB4N"};